export default {
  marshal: (data) => {
    return data.reduce((acc, field) => {
      const { fieldCode, value } = field;
      if (typeof value === 'boolean') {
        return acc;
      }
      return {
        ...acc,
        [fieldCode]: value,
      };
    }, {});
  },
};
